<template>
    <!-- No Template Required -->
</template>

<script setup>

import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAppStore } from "@/stores/AppStore";
import Toast from "@/services/Toast";

const router = useRouter();
const appStore = useAppStore();

onMounted(async () =>
{
    await appStore.setAccount(null);
    Toast.success("You have successfully logged out.");
    router.push({
        path: "/login"
    });
});


</script>